var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"id":"helpDetail"}},[_c('el-main',[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }